import { StandaloneTrackingProps } from '@/base/components/element/Tracking';
import { StandaloneLayoutProps } from '@/components/layout/Base';
import { EmptyObject } from '@/types/utils';
import { loadHeaderData, loadNavigationData } from 'lib/data';
import component, { standaloneComponent } from 'modules/dynamic-components';
import { GetStaticProps, NextPage } from 'next';

const Layout = standaloneComponent<StandaloneLayoutProps>('LayoutBase');
const Tracking = standaloneComponent<StandaloneTrackingProps>('ElementTracking');

const Page404 = component<EmptyObject>('PostType404');
const Consent = component<EmptyObject>('ElementConsent');

interface PageProps {
  // It's deprecated, only used by residence
  layoutData: { [key: string]: object };
}

const Page: NextPage<PageProps> = ({ layoutData }) => {
  return (
    <Layout
      {...layoutData}
      content={
        <>
          <Consent />
          <Tracking />
          <Page404 />
        </>
      }
    />
  );
};

export default Page;

export const getStaticProps: GetStaticProps = async (context) => {
  const route = ['index'];

  const layoutData = {
    headerData: await loadHeaderData(route),
    navigationData: await loadNavigationData(route),
  };

  return {
    props: {
      layoutData,
    },
    revalidate: 3600,
  };
};
